import React, { useState } from "react";
import styles from "./styles.module.css";
import { toast } from "react-toastify";

const UploadMaterial = ({ showMaterialModal, setShowMaterialModal, materialType, onAdd }) => {
  const [link, setLink] = useState("");
  const [file, setFile] = useState(null);

  if (!showMaterialModal) return null;

  const handleAdd = () => {
    if (materialType === "Link") {
      if (!link) return toast.warn("Please enter a link");
      onAdd({ type: "Link", value: link });
      setLink("");
    } else {
      if (!file) return toast.warn("Please select a file");
      onAdd({ type: "File", value: file });
      setFile(null);
    }
    setShowMaterialModal(false);
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal}>
        <i
          className={`${styles.closeBtn} fas fa-close`}
          onClick={() => setShowMaterialModal(false)}
          style={{ position: 'absolute', right: '20px', top: '20px', cursor: 'pointer' }}
        ></i>
        {materialType === "Link" ? (
          <div className={styles.addLink}>
            <h4>Material Link</h4>
            <input
              type="url"
              required
              placeholder="Enter link"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              className={styles.modalInput}
            />
            <div className={styles.modalButtons}>
              <button className={styles.cancelBtn} onClick={() => setShowMaterialModal(false)}>Cancel</button>
              <button className={styles.addBtn} onClick={handleAdd}>Add</button>
            </div>
          </div>
        ) : (
          <div className={styles.addFile}>
            <h4>Upload File</h4>
            <div className={styles.chooseFiles}>
              <label className={styles.fileUploadBtn}>
                {file ? file.name : "Choose File"} <i className="fas fa-upload"></i>
                <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </label>
            </div>
            <div className={styles.modalButtons}>
              <button className={styles.cancelBtn} onClick={() => setShowMaterialModal(false)}>Cancel</button>
              <button className={styles.addBtn} onClick={handleAdd}>Add</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadMaterial;
